'use client';

import { Button } from '@modules/prism-client/components/elements';
import { useDialogTelemetry } from '@modules/prism-client/lib/telemetry';
import { Dialog, DialogContent } from '@tuic/web-compositions/shared/Dialog';
import { useState } from 'react';

import { AddBookingForm } from './AddBookingForm';

import type PrismAPI from '@modules/prism-client/types/prism-types';
import type { FC } from 'react';

type AddBookingDialogProps = {
  title: string;
  openButton: PrismAPI.ButtonElement;
  form: PrismAPI.Form;
};

export const AddBookingDialog: FC<AddBookingDialogProps> = ({
  title,
  openButton,
  form,
}) => {
  const [open, setOpen] = useState(false);

  useDialogTelemetry(openButton.telemetry, open);

  return (
    <>
      <Button data={openButton} onClick={() => setOpen(true)} />
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent bodyClassName="bg-white" title={title}>
          <AddBookingForm form={form} onSuccess={() => setOpen(false)} />
        </DialogContent>
      </Dialog>
    </>
  );
};
